module.exports = __webpack_public_path__ + "img/11exp.51d2b841.jpg";